const MuiInputAdornment = {
    root: {

    },
};

export default MuiInputAdornment;
